import { Box, Typography } from '@mui/material';
import { colorTokens, typographyTokens } from '../app/designTokens';
import { SectionCard } from './SectionCard';

const { semantic } = colorTokens;

/**
 * Compact metric / detail field card (Surface / Card pattern).
 */
export function InfoCard({ label, value, children, sx }) {
  return (
    <SectionCard
      variant="Default"
      sx={{
        mb: 0,
        height: '100%',
        ...sx,
      }}
    >
      <Typography
        sx={{
          display: 'block',
          mb: 1,
          fontFamily: typographyTokens.fontFamily,
          fontSize: 12,
          lineHeight: '16px',
          letterSpacing: '0.24px',
          color: semantic.text.muted,
        }}
      >
        {label}
      </Typography>
      {children || (
        <Typography
          component="div"
          sx={{
            fontFamily: typographyTokens.fontFamily,
            fontWeight: typographyTokens.fontWeightSemibold,
            fontSize: 14,
            lineHeight: '20px',
            color: semantic.text.primary,
            wordBreak: 'break-word',
          }}
        >
          {value ?? '—'}
        </Typography>
      )}
    </SectionCard>
  );
}

/**
 * Label/value pair for detail section layouts.
 */
export function DetailField({ label, value, children }) {
  return (
    <Box sx={{ minWidth: 0, maxWidth: '100%' }}>
      <Typography
        sx={{
          mb: 0.5,
          fontSize: 12,
          lineHeight: '16px',
          letterSpacing: '0.24px',
          color: semantic.text.muted,
        }}
      >
        {label}
      </Typography>
      {children ? (
        <Box
          sx={{
            minWidth: 0,
            maxWidth: '100%',
            overflowWrap: 'anywhere',
            wordBreak: 'break-word',
          }}
        >
          {children}
        </Box>
      ) : (
        <Typography
          sx={{
            fontFamily: typographyTokens.fontFamily,
            fontWeight: typographyTokens.fontWeightSemibold,
            fontSize: 13,
            lineHeight: '18px',
            color: semantic.text.primary,
            minWidth: 0,
            maxWidth: '100%',
            overflowWrap: 'anywhere',
            wordBreak: 'break-word',
          }}
        >
          {value ?? '—'}
        </Typography>
      )}
    </Box>
  );
}
